/** Seeded xorshift32. Deterministic across engines: only integer ops. */
export interface Rng {
  state: number;
}

export function createRng(seed: number): Rng {
  const s = seed >>> 0;
  return { state: s === 0 ? 0x9e3779b9 : s };
}

/** Next unsigned 32-bit integer. Mutates rng. */
export function nextU32(rng: Rng): number {
  let x = rng.state;
  x ^= x << 13;
  x >>>= 0;
  x ^= x >>> 17;
  x ^= x << 5;
  x >>>= 0;
  rng.state = x;
  return x;
}

/** Float in [0, 1). Uses only the top 24 bits so the division is exact. */
export function nextFloat(rng: Rng): number {
  return (nextU32(rng) >>> 8) / 16777216;
}

/** Integer in [0, n). */
export function nextInt(rng: Rng, n: number): number {
  return Math.floor(nextFloat(rng) * n);
}
